import YouTubeVideo from "@atoms/players/YouTubeVideo";
import { getYoutubeid } from "@pages/Article/components/ArticleMainMedia/utils/helpers";
import { ArticleIndividualMediaProps } from "@pages/Article/components/ArticleMainMedia/utils/types";
import { getFormattedUrlPath } from "@util/helpers";

/**
 * ArticleYoutubeMedia component that renders a YouTube video player
 * for the main media of an article.
 */
const ArticleYoutubeMedia = ({
  media,
}: ArticleIndividualMediaProps): React.ReactElement => {
  const youtubeUrlPath = media.youtubeUrlPath || "";
  const videoId = getYoutubeid(youtubeUrlPath);

  const param = [{ key: "enablejsapi", value: "1" }];

  const videoUrl = `https://www.youtube.com/embed/${videoId}`;

  const videoMedia = {
    ...media,
    src: getFormattedUrlPath(videoUrl, param),
  };

  return (
    <YouTubeVideo
      className="w-full"
      src={videoMedia.src}
      title={media.title || ""}
    />
  );
};

export default ArticleYoutubeMedia;
